// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e3e2c49a","453":"9d08e576","732":"2f2ddf65"}[chunkId] + ".chunk.js";
};